import React, {} from 'react';
// The inner shapes of ui-ux-design/current/icons/*.svg (24-unit viewBox, stroke 1.75, round caps), exactly the 14 names
// the app frame mapping accepts. map.svg and note.svg wait for the screen that draws them.
export const ICON_SHAPES = {
    plus: React.createElement("path", { d: "M12 5v14M5 12h14" }),
    x: React.createElement("path", { d: "M18 6 6 18M6 6l12 12" }),
    'chevron-down': React.createElement("path", { d: "m6 9 6 6 6-6" }),
    'chevron-left': React.createElement("path", { d: "m15 18-6-6 6-6" }),
    'chevron-right': React.createElement("path", { d: "m9 18 6-6-6-6" }),
    'arrow-left': React.createElement("path", { d: "M19 12H5M12 19l-7-7 7-7" }),
    calendar: (React.createElement(React.Fragment, null,
        React.createElement("rect", { x: "3", y: "4.5", width: "18", height: "16.5", rx: "2" }),
        React.createElement("path", { d: "M16 2.5v4M8 2.5v4M3 10h18" }))),
    pencil: (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M12 20h9" }),
        React.createElement("path", { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" }))),
    alert: (React.createElement(React.Fragment, null,
        React.createElement("circle", { cx: "12", cy: "12", r: "9.5" }),
        React.createElement("path", { d: "M12 7.5v5M12 16.2v.1" }))),
    info: (React.createElement(React.Fragment, null,
        React.createElement("circle", { cx: "12", cy: "12", r: "9.5" }),
        React.createElement("path", { d: "M12 11v5.5M12 7.8v.1" }))),
    check: React.createElement("path", { d: "M20 6 9 17l-5-5" }),
    'check-circle': (React.createElement(React.Fragment, null,
        React.createElement("circle", { cx: "12", cy: "12", r: "9.5" }),
        React.createElement("path", { d: "m8 12.5 2.8 2.8L16.5 9.5" }))),
    'log-out': React.createElement("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" }),
    mail: (React.createElement(React.Fragment, null,
        React.createElement("rect", { x: "2.5", y: "4.5", width: "19", height: "15", rx: "2" }),
        React.createElement("path", { d: "m3 6.5 9 6.5 9-6.5" })))
};
export const ICON_NAMES = [
    'plus',
    'x',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'arrow-left',
    'calendar',
    'pencil',
    'alert',
    'info',
    'check',
    'check-circle',
    'log-out',
    'mail'
];
//# sourceMappingURL=iconShapes.js.map